module.exports = __webpack_public_path__ + "img/hair.f522e1ea.jpg";